export const RadioGroupDirection = { Horizontal: 'horizontal', Vertical: 'vertical' } as const;
export type RadioGroupDirectionType =
  (typeof RadioGroupDirection)[keyof typeof RadioGroupDirection];

export type RadioGroupColorType = 'primary' | 'orange' | 'green' | 'red';
